import view from './view.html';

/* @ngInject */
export default function () {
	return {
		restrict:                   'A',
		transclude:                 true,
		template:                   view,
		priority:                   1000,
		scope:                      {
			status:  '=?statusIfUnloaded',
			visible: '@',
		},
		controller: /* @ngInject */ ($scope, StatusService) => {
			$scope.visible = StatusService.isUnloaded($scope.status);

			$scope.$watch('status', (status) => {
				$scope.visible = StatusService.isUnloaded(status);
			});
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/status/ifUnloaded/index.js